import { useIncidentDetail } from 'core/components/JianDetail/hooks/useIncidentDetail';
import { enumTranslator } from './enumTranslator';

export type IncidentDetail = ReturnType<
  typeof useIncidentDetailForNiigata
>['incidentDetailData']['incidentInfo'];
export type IncidentDetailEmsTeam = ReturnType<
  typeof useIncidentDetailForNiigata
>['incidentDetailData']['emsTeamInfo'];
export type IncidentDetailPatients = ReturnType<
  typeof useIncidentDetailForNiigata
>['incidentDetailData']['patientInfo'];
export type IncidentDetailPatient = ReturnType<
  typeof useIncidentDetailForNiigata
>['incidentDetailData']['patientInfo'][number];
export type PatientTimeSeries = ReturnType<
  typeof useIncidentDetailForNiigata
>['incidentDetailData']['patientInfo'][number]['timeSeries'];
export type ActivityRecordPdf = ReturnType<
  typeof useIncidentDetailForNiigata
>['incidentDetailData']['patientInfo'][number]['activityRecordPdf'][number];

export const useIncidentDetailForNiigata = () => {
  const { incidentDetailData, isError } = useIncidentDetail();
  const data = enumTranslator(incidentDetailData);
  return {
    incidentDetailData: data,
    isError,
  };
};
